export default {
    book_now: 'Резервишите сада',
    minimum_age: 'Само преко {age}',
    excess_liability: 'Смањење одговорности',
    security_deposit: 'Сигурносни депозит',
    fuel_policy: 'Политика горива',
    like_for_like: 'Колико на почетку толико на крају',
    full_to_full: 'Са пуним резервоаром на почетку и на крају',
    miles_per_rental: '{mileage} бесплатних миља по изнајмљивању',
    km_per_rental: '{mileage} бесплатних километара по изнајмљивању',
    unlimited_mileage: 'Неограничена миљажа',
    unlimited_mileage_km: 'Неограничена миљажа',
    non_amendable: 'Не може се изменити',
    non_refundable: 'Не може се вршити поврат новца',
    free_cancellation_until: 'Бесплатно отказивање до',
    cancellation_in_line_with: 'Отказивање у складу са',
    tcs: 'Условима коришћења',
    free_extras_on_collection: 'Два бесплатна додатка на наплату',
    glass_and_tyres_covered: 'Стакло и гуме су покривени',
    number_of_passengers: 'Број путника',
    number_of_bags: 'Број торби',
    fuel_type: 'Тип горива',
    co2: 'CO2',
    aircon: 'Клима',
    transmission: 'Пренос',
    book_type: 'Резервишите {type}',
    debit_card_deposit: 'Дебитна картица прихваћена за депозите',
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/sr/quotes/price_card.js